import { render, staticRenderFns } from "./ActiveLeadsModal.vue?vue&type=template&id=207ae95b&scoped=true"
import script from "./ActiveLeadsModal.vue?vue&type=script&lang=js"
export * from "./ActiveLeadsModal.vue?vue&type=script&lang=js"
import style0 from "./ActiveLeadsModal.vue?vue&type=style&index=0&id=207ae95b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207ae95b",
  null
  
)

export default component.exports